import { FC } from "react";
import { ButtonProps as AntdButtonProps } from "antd";

import { StyledButton } from "./styles";

type ButtonProps = Omit<AntdButtonProps, "type"> & {
  type?: AntdButtonProps["type"] | "gradient";
};

const Button: FC<ButtonProps> = ({ type, ...props }) => {
  return (
    <StyledButton
      {...props}
      type={type === "gradient" ? "primary" : type}
      $gradient={type === "gradient"}
    />
  );
};

export default Button;
